module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-13.1b59448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-13.jpg
// module id = kD7y
// module chunks = 0